module.exports = __webpack_public_path__ + "assets/img/Takedowns.bad7d9ea.jpg";